import * as sharedStyles from 'owa-timestream-asset-sdk-filepicker/lib/components/styles.scss';
import * as imageStyles from './styles.scss';
import type { ImagePayload } from '../schema';
import { ControlIcons } from 'owa-control-icons';
import {
    AssetIcon,
    AssetError,
    AssetErrorType,
    AssetErrorRetryable,
} from 'owa-timestream-asset-sdk';
import type { AssetCommonViewProps } from 'owa-timestream-asset-sdk-types';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { imagePlaceholderText, assetErrorNoImage } from '../imagepickerStrings.locstring.json';
import useImageViewState from '../hooks/useImageViewState';
import loc from 'owa-localize';
import ImageSource from './ImageSource';

/** Renders a Image asset */
export default observer(function ImageView(props: AssetCommonViewProps<ImagePayload>) {
    const {
        filePickerLinkData,
        thumbnailUrl,
        assetErrorProps,
        retryFetchUrlInfo,
    } = useImageViewState(props);

    if (assetErrorProps.errorType && assetErrorProps.errorType !== AssetErrorType.Retryable) {
        return <AssetError {...assetErrorProps} />;
    }

    if (props.isNewlyCreated || (!filePickerLinkData.fileName && !filePickerLinkData.mimeType)) {
        return (
            <div className={sharedStyles.emptyAsset}>
                <AssetIcon iconName={ControlIcons.FileImage} className={sharedStyles.attachIcon} />
                <div className={sharedStyles.placeholderText}>{loc(imagePlaceholderText)}</div>
            </div>
        );
    }

    return (
        <div className={imageStyles.imgContainer}>
            {filePickerLinkData?.fileName ? (
                <>
                    <ImageSource thumbnailUrl={thumbnailUrl} />
                    {assetErrorProps.errorType === AssetErrorType.Retryable && (
                        <AssetErrorRetryable
                            errorDesc={loc(assetErrorNoImage)}
                            retryCallback={retryFetchUrlInfo}
                        />
                    )}
                </>
            ) : (
                <AssetError assetType={'image'} />
            )}
        </div>
    );
});
